import { configureStore } from '@reduxjs/toolkit';
// TODO fix no cycle error
// eslint-disable-next-line import/no-cycle
import navBarReducer from './slices/navbarSlice';
// eslint-disable-next-line import/no-cycle
import walletPopupReducer from './slices/walletPopupSlice';

export const store = configureStore({
  reducer: {
    navBar: navBarReducer,
    walletPopup: walletPopupReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
